module.exports = __webpack_public_path__ + "static/SectionOne-54d254d16d440ba8c18701c7392b1c62.png";